const MS_PER_DAY = 1000 * 60 * 60 * 24;

const trialDaysRemaining = (expiration: string, now: Date = new Date()): number => {
	const expiry = new Date(expiration).getTime();
	if (Number.isNaN(expiry)) return 0;
	const diff = expiry - now.getTime();
	if (diff <= 0) return 0;
	return Math.ceil(diff / MS_PER_DAY);
};

export default trialDaysRemaining;
